/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdjuntoIncidenciaModelDto } from '../../models/adjunto-incidencia-model-dto';

export interface DoctorAlertaControllerObtenerAdjuntoIncidencia$Params {
  uuidIncidencia: string;
}

export function doctorAlertaControllerObtenerAdjuntoIncidencia(http: HttpClient, rootUrl: string, params: DoctorAlertaControllerObtenerAdjuntoIncidencia$Params, context?: HttpContext): Observable<StrictHttpResponse<AdjuntoIncidenciaModelDto>> {
  const rb = new RequestBuilder(rootUrl, doctorAlertaControllerObtenerAdjuntoIncidencia.PATH, 'get');
  if (params) {
    rb.path('uuidIncidencia', params.uuidIncidencia, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdjuntoIncidenciaModelDto>;
    })
  );
}

doctorAlertaControllerObtenerAdjuntoIncidencia.PATH = '/api/doctor-alertas/obtener-adjunto-incidencia/{uuidIncidencia}';
